var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptySearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c{fill:#fff;}.a{stroke:#f8644f;stroke-width:2px;}.b{fill:#f8644f;}.d{stroke:none;}.e{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4688 -9663)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(4688 9663)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 28,
    cy: 28,
    r: 28
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 28,
    cy: 28,
    r: 27
  })), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    transform: "translate(4700 9675)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1.584-12.258a5.051,5.051,0,0,1,2.682-.7,4.9,4.9,0,0,1,1.98.378,3.16,3.16,0,0,1,1.341,1.044A2.589,2.589,0,0,1,8.064-9.99a2.957,2.957,0,0,1-.441,1.638A10.548,10.548,0,0,1,6.3-6.768,11.5,11.5,0,0,0,5.184-5.481a2.642,2.642,0,0,0-.468,1.2l-.072.5H3.312v-.738a3.657,3.657,0,0,1,.36-1.7,8.375,8.375,0,0,1,1.044-1.5A7.565,7.565,0,0,0,5.5-8.784,1.972,1.972,0,0,0,5.76-9.792a1.183,1.183,0,0,0-.441-.981A1.9,1.9,0,0,0,4.1-11.124a4.78,4.78,0,0,0-2.52.774ZM2.736-2.52H5.274V0H2.736Z",
    transform: "translate(4711.416 9697.96)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySearch);
export default __webpack_public_path__ + "static/media/empty-search.5506a9c1c865a29aa6de60b0755e8b6a.svg";
export { ForwardRef as ReactComponent };